module.exports = __webpack_public_path__ + "img/HZ-B5064.12413824.jpg";